'use es6';

/* global hubspot */
import { scrollToPositionInHash } from './lib/scrollHashUtils';
import { cleanupInvalidDomIfNeeded } from './lib/domUtils/instanceEditingCleanupUtils';

// Note, I believe the CMS platform is (slowly) in progress moving away from having a jquery dependency
// in pages, so it is worth us starting to trim our dependency on jquery as we move forward
import $ from 'jquery';
import Application from 'InpageEditorUI/lib/Application';

// Setting jQuery reference as part of a global variable for selenium helpers
window.hs = window.hs = {};
window.hs.jQuery = $;
function previewFrameCleanupAndPrep() {
  // Set enviro variables for the editor preview environment
  if (window.location.search.includes('localAssets=true')) {
    window.DEPLOYED = false;
  } else {
    window.DEPLOYED = true;
  }
  if (
  // Cookie that is set internally in prepareAppSession
  document.cookie.includes('hs_selenium') ||
  // Fallback to checking for query string
  window.location.href.indexOf('seleniumRunning') > -1) {
    window.SELENIUM_IS_RUNNING = true;
  }
  if (window.location.search.includes('env=qa')) {
    window.ENV = 'qa';
  }
  if (window.hs == null) {
    window.hs = {};
  }
  if (window._hsq == null) {
    window._hsq = [];
  }

  // IE10 missing
  if (document.location.origin == null) {
    document.location.origin = `${document.location.protocol}//${document.location.hostname}`;
  }

  // TODO, convert to vanilla JS
  $('html, body').attr('style', (i, currStyle) => {
    const styleOverrides = 'overflow: auto !important; height: auto !important';
    if (currStyle) {
      return `${currStyle}; ${styleOverrides}`;
    }
    return styleOverrides;
  });

  // TODO, convert to vanilla JS
  $('html').addClass('hs-inline-edit');
}
function preventAutomaticPageScrollRestoration() {
  if (window.history.scrollRestoration) {
    window.history.scrollRestoration = 'manual';
  }
}
export function startInpage(config = {}) {
  previewFrameCleanupAndPrep();
  preventAutomaticPageScrollRestoration();
  scrollToPositionInHash();
  window.hs.app = new Application();
  window.hs.app.initialize(config);
  window.hs.app.startPreDomReady();
  $(() => {
    try {
      cleanupInvalidDomIfNeeded();
      window.hs.app.startPostDomReady();
    } catch (error) {
      window.hs.app.logError(error);
    }
  });
}

// Set flag that customers' JS can use to detect if the page is being rendered in the editor preview
// (introduced in https://issues.hubspotcentral.com/browse/COSBLOG-2475 via https://git.hubteam.com/HubSpot/ContentEditorUI/pull/482)
window.hsInEditor = true;